import { render, staticRenderFns } from "./c-user-info.vue?vue&type=template&id=225be09f&scoped=true&"
import script from "./c-user-info.vue?vue&type=script&lang=js&"
export * from "./c-user-info.vue?vue&type=script&lang=js&"
import style0 from "./c-user-info.vue?vue&type=style&index=0&id=225be09f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225be09f",
  null
  
)

export default component.exports